import React, { FC } from "react";
import MainNav1 from "./MainNav1";
import { Helmet } from "react-helmet";
import { useEffect } from "react";
import { useState } from "react";

export interface HeaderProps {
  credential: User;
  notification:any;
  count:any
}

const Header: FC<HeaderProps> = ({ credential,notification,count }) => {
  const [isTop, setisTop] = useState(true);

  useEffect(() => {
    window.onscroll = function () {
      scrollFunction();
    };
  }, []);

  function scrollFunction() {
    const $head = document.getElementById("nc-chifis-header");
    if (!$head) return;
    if (
      document.body.scrollTop > 20 ||
      document.documentElement.scrollTop > 20
    ) {
      !!isTop && setisTop(false);
    } else {
      setisTop(true);
    }
  }


  return (
    <div
      id="nc-chifis-header"
      className="nc-Header sticky top-0 w-full left-0 right-0 z-40"
    >
      <Helmet>
        <title>GuideSantai</title>
      </Helmet>
      <MainNav1 isTop={isTop} credential={credential} notification={notification} count={count} />
    </div>
  );
};

export default Header;
